import { DatePicker } from '@ui-framework/index';
import { forwardRef, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

const EndDate = forwardRef((props, ref) => {
  const { control, setValue } = useFormContext();
  const startDate = useWatch({
    control,
    name: 'startDate',
  });
  const endDate = useWatch({
    control,
    name: 'endDate',
  });

  useEffect(() => {
    if (!startDate) {
      setValue('endDate', null);
    } else if (dayjs(startDate) >= dayjs(endDate)) {
      setValue('endDate', null);
    }
  }, [startDate, endDate]);

  return (
    <DatePicker
      ref={ref}
      name="endDate"
      {...props}
      disabled={props?.disabled ? props?.disabled : !startDate}
      {...(startDate && { minDate: dayjs(startDate).add(1, 'day') })}
      {...(!startDate && {
        slotProps: {
          textField: {
            helperText: (
              <FormattedMessage
                id="PLEASE_SELECT_START_DATE_TO_ENABLE_THIS_FIELD"
                defaultMessage="Please select a start date to enable this field"
              />
            ),
          },
        },
      })}
    />
  );
});

export default EndDate;
